import { apiRequest } from '@services/apiClient';
import toursEndpoints from '@services/tours/toursEndpoints';

// Creates a new tour in CMS.
export function createTourRequest(payload) {
  return apiRequest(toursEndpoints.base, {
    method: 'POST',
    body: payload
  });
}

// Fetches tours for the map tools index with pagination/search.
export function listToursRequest({ page = 1, pageSize = 10, search = '' } = {}) {
  const params = new URLSearchParams();
  params.set('page', String(page || 1));
  params.set('pageSize', String(pageSize || 10));
  if (String(search || '').trim()) {
    params.set('search', String(search || '').trim());
  }
  return apiRequest(`${toursEndpoints.base}?${params.toString()}`);
}

// Updates an existing tour by id.
export function updateTourRequest(id, payload) {
  return apiRequest(toursEndpoints.byId(id), {
    method: 'PUT',
    body: payload
  });
}

// Deletes an existing tour by id.
export function deleteTourRequest(id) {
  return apiRequest(toursEndpoints.byId(id), {
    method: 'DELETE'
  });
}
